import { Lock } from 'lucide-react';
import { ButtonLink } from '../components/Button';
import { EmptyState } from '../components/EmptyState';
import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';

export function ForbiddenPage() {
  return (
    <>
      <PageHeader title="Brak dostępu" />
      <PageBody>
        <EmptyState
          icon={Lock}
          title="Ta część jest dostępna tylko dla kierownika"
          action={
            <ButtonLink to="/kalendarz" variant="secondary">
              Przejdź do kalendarza
            </ButtonLink>
          }
        />
      </PageBody>
    </>
  );
}
